import dateFormat from 'dateformat';

export default {
  dateStampFormater(date){
    const year = dateFormat(date, "d/MM/yy");
    return year;
  },
  timeFormater(date){
    const time = dateFormat(date, "H:MM tt");
    return time;
  },
  dateFullFormat(date){
    const time = dateFormat(date, "d/mm/yy H:MM tt");
    return time;
  }
}